import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { catchError, Observable, of } from "rxjs";
import { CalendarEvent, CalendarViewLabel, CalendlySettings, environment, EventsSearchParams, FiltersSearchEvents } from "src/index";
import { LoadingService } from "src/index/services.index";

@Injectable({
    providedIn: 'root'
})
export class EventsService {
    loadingService = inject(LoadingService);
    httpClient = inject(HttpClient);

    eventsColorMap = new Map<string, string>();
    colorIndex = 0;
    colorPalette = environment.calendarModule?.colorPalette ?? [];

    getPropForColorMapping(event: CalendarEvent) {
        return event.courseId;
    }

    getColorForEvent(eventColorId: string): string {
        if (this.eventsColorMap.has(eventColorId)) {
            return this.eventsColorMap.get(eventColorId)!;
        }

        const color = this.colorPalette[this.colorIndex % this.colorPalette.length];
        this.eventsColorMap.set(eventColorId, color);

        this.colorIndex++;

        return color;
    }

    getEvents(facetField?: string, searchParams?: EventsSearchParams): Observable<FiltersSearchEvents> {
        if (environment.events) {
            return this.httpClient.post<FiltersSearchEvents>(`${environment.events}`, {
                facetField,
                ...searchParams
            }).pipe(
                catchError(() => of({ events: [] })),
            );
        }

        return of({ events: [] });
    }

    getCalendly() {
        if (environment.calendly) {
            return this.httpClient.get<CalendlySettings>(`${environment.calendly}`).pipe(
                catchError(() => of(undefined)),
            );
        }

        return of(undefined);
    }

    getCalendarViewFromLabel(label: CalendarViewLabel) {
        switch(label){
            /* @fullcalendar/daygrid */
            case "monthLabel":
                return 'dayGridMonth';
            case "weekLabel":
                return 'timeGridWeek';
            /* custom */
            case "listLabel":
                return 'listLabel';
        }
        
    }

}